// eslint-disable-next-line no-shadow
export enum ErrorRequest {
  badRequest = 400,
  notFound = 404,
  expiredToken = 401
}
